import React from 'react';
import { MessageCircle, MapPin } from 'lucide-react';

export const Hero = () => {
  return (
    <section className="relative pt-24 pb-16 bg-gradient-to-br from-orange-50 via-amber-50 to-red-50 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/79oe64c1_IMG_3098.jpeg" 
          alt="Japan Background"
          className="w-full h-full object-cover opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-orange-50/70 via-amber-50/70 to-red-50/70"></div>
      </div>
      
      <div className="absolute inset-0 opacity-5 z-0">
        <div className="absolute top-20 left-10 w-72 h-72 bg-orange-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-red-400 rounded-full blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Únete a grupos de{' '}
            <span className="bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text text-transparent">
              WhatsApp de viajeros
            </span>
          </h2>
          
          <p className="text-lg sm:text-xl text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed">
            Conecta con otros viajeros, resuelve dudas, comparte experiencias y descubre consejos locales para tu próximo destino
          </p>
          
          <div className="flex flex-wrap justify-center gap-6 mb-12">
            <div className="flex items-center gap-3 bg-white px-6 py-3 rounded-full shadow-sm">
              <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center">
                <MapPin className="w-5 h-5 text-amber-600" />
              </div>
              <div className="text-left">
                <p className="text-sm text-gray-500">Grupos en</p>
                <p className="text-lg font-bold text-gray-900">38 destinos</p>
              </div>
            </div>
            
            <div className="flex items-center gap-3 bg-white px-6 py-3 rounded-full shadow-sm">
              <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                <MessageCircle className="w-5 h-5 text-red-600" />
              </div>
              <div className="text-left">
                <p className="text-sm text-gray-500">100% gratis</p>
                <p className="text-lg font-bold text-gray-900">Únete ahora</p>
              </div>
            </div>
          </div>
          
          <a 
            href="#destinos" 
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-orange-600 to-red-600 text-white font-semibold rounded-full hover:shadow-xl transition-all duration-300 hover:scale-105"
          >
            Ver todos los destinos
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};
